module.exports = __webpack_public_path__ + "1.4.15-unryo/img/speedtest.4c5602d4.png";